module.exports = __webpack_public_path__ + "static/media/SFiOBOA_nn_primærlogo_sentrert_logo_neg.2b6e52f0.pdf";